import React from 'react';
import { motion } from 'framer-motion';
export function BookPreview() {
  return <section className="py-12 px-4 bg-cream" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 space-y-3" data-id="element-125">
          <p className="text-lg md:text-xl text-navy/80 leading-relaxed font-medium" data-id="element-126">
            Para que veas exactamente lo que vas a recibir…
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-navy" data-id="element-127">
            Una de las primeras páginas que muchos cuidadores leen y sienten
            como propia.
          </p>
          <p className="text-lg md:text-xl text-terracotta italic font-medium" data-id="element-128">
            "Si estas palabras te resultan familiares, este libro fue escrito
            para ti"
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative" data-id="element-129">
          <div className="absolute inset-0 bg-terracotta/10 transform rotate-1 rounded-2xl" data-id="element-130" />
          <img src="https://cdn.magicpatterns.com/uploads/bxGKYbQSYAJ78rbx6RNXxB/image.png" alt="Prólogo del libro — No Estás Exagerando" className="relative rounded-2xl shadow-xl w-full" data-id="element-131" />
        </motion.div>

        <p className="text-center text-lg md:text-xl text-navy/70 italic font-medium mt-6" data-id="element-132">
          Este es uno de los primeros textos que encontrarás dentro del libro.
        </p>
      </div>
    </section>;
}